import { render, staticRenderFns } from "./editorialProjectDetailModal.vue?vue&type=template&id=845d9572&"
import script from "./editorialProjectDetailModal.vue?vue&type=script&lang=ts&"
export * from "./editorialProjectDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports